/* eslint-disable class-methods-use-this */

class MobileMenu extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.initialiseEventListeners();
    });
  }

  openPage(key) {
    this.querySelector('[data-mobile-nav-page="root"]').classList.add(
      '-translate-x-full'
    );

    this.querySelector(`[data-mobile-nav-page="${key}"]`).classList.remove(
      'translate-x-full'
    );
  }

  closePage() {
    [...this.querySelectorAll('[data-mobile-nav-page]')].forEach(page => {
      if (page.dataset.mobileNavPage === 'root') {
        page.classList.remove('-translate-x-full');
      } else {
        page.classList.add('translate-x-full');
      }
    });
  }

  openMenu() {
    this.parentElement.classList.remove('translate-x-full');
    document.addEventListener('click', e => this.closeOnOutsideClick(e));
    window.addEventListener('scroll', () => this.closeOnScroll());
  }

  closeMenu() {
    this.parentElement.classList.add('translate-x-full');
    document.removeEventListener('click', e => this.closeOnOutsideClick(e));
    window.removeEventListener('scroll', () => this.closeOnScroll());
  }

  closeOnScroll() {
    this.closeMenu();
  }

  closeOnOutsideClick(e) {
    if (
      this.contains(e.target) ||
      typeof e.target.dataset.openMobileMenu !== 'undefined' ||
      document.querySelector('[data-open-mobile-menu]').contains(e.target)
    ) {
      return;
    }

    this.closeMenu();
  }

  initialiseEventListeners() {
    [...this.querySelectorAll('[data-close-mobile-nav-page]')].forEach(
      trigger => {
        trigger.addEventListener('click', () => this.closePage());
      }
    );

    [...this.querySelectorAll('[data-open-mobile-nav-page]')].forEach(
      trigger => {
        trigger.addEventListener('click', () => {
          this.openPage(trigger.dataset.openMobileNavPage);
        });
      }
    );

    document
      .querySelector('[data-open-mobile-menu]')
      .addEventListener('click', () => this.openMenu());

    [...this.querySelectorAll('[data-close-mobile-menu]')].forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.closeMenu();
        this.closePage();
      });
    });

    [...this.querySelectorAll('[data-mobile-nav-submenu-title]')].forEach(
      trigger => {
        trigger.addEventListener('click', () => {
          trigger
            .querySelector('ul')
            .classList.toggle('!max-h-screen', trigger.dataset.state === '0');

          trigger.setAttribute(
            'data-state',
            Number(trigger.dataset.state === '0')
          );
        });
      }
    );
  }
}

customElements.define('mobile-menu', MobileMenu);
